import Button from '@standardsdigital/ui-components/Button';
import { useTranslation } from 'react-i18next';
import styles from '../FormCard.module.css';

interface FormCardFooterProps {
  onSave?: () => void;
  onCancel?: () => void;
  disabled: boolean;
  loading: boolean;
  showCancelButton: boolean;
  showChangesCounter: boolean;
  dirtyFieldsCount: number;
}

function FormCardFooter({
  onSave,
  onCancel,
  disabled,
  loading,
  showCancelButton,
  showChangesCounter,
  dirtyFieldsCount,
}: Readonly<FormCardFooterProps>) {
  const { t } = useTranslation();
  const changesCounterText = showChangesCounter
    ? `${dirtyFieldsCount} ${t('general.unsavedChanges')}`
    : '';

  return (
    <div className={styles.footer}>
      <p className={styles.changesCounter}>{changesCounterText}</p>
      {showCancelButton && onCancel ? (
        <Button
          variant="secondary"
          type="button"
          onClick={onCancel}
          disabled={loading || disabled}
        >
          {t('general.cancel')}
        </Button>
      ) : null}
      {onSave ? (
        <Button
          variant="primary"
          type="button"
          onClick={onSave}
          disabled={loading || disabled}
        >
          {t('general.save')}
        </Button>
      ) : null}
    </div>
  );
}

export default FormCardFooter;
